<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Legendary Locals of Toledo</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head1"><a id="page_5">CONTENTS</a></p><a id="page_5">
</a><p class="in-para"><a id="page_5"></a><span href="#/Title" title="Link target outside of Sample">Title Page</span></p>
<p class="in-para"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></p>
<p class="in-para"><a href="#/Acknowledgments#Ack">Acknowledgments</a></p>
<p class="in-para"><a href="#/Introduction#Intro">Introduction</a></p>
<p class="in-para"><a href="#/Chapter1#C1">CHAPTER ONE</a>   <a href="#/Chapter1#C1">Pioneers</a></p>
<p class="in-para"><span href="#/Chapter2#C2" title="Link target outside of Sample">CHAPTER TWO</span>   <span href="#/Chapter2#C2" title="Link target outside of Sample">Business and Industry</span></p>
<p class="in-para"><span href="#/Chapter3#C3" title="Link target outside of Sample">CHAPTER THREE</span>   <span href="#/Chapter3#C3" title="Link target outside of Sample">Government and the Law</span></p>
<p class="in-para"><span href="#/Chapter4#C4" title="Link target outside of Sample">CHAPTER FOUR</span>   <span href="#/Chapter4#C4" title="Link target outside of Sample">The Arts, Entertainers, and Sports Figures</span></p>
<p class="in-para"><span href="#/Chapter5#C5" title="Link target outside of Sample">CHAPTER FIVE</span>   <span href="#/Chapter5#C5" title="Link target outside of Sample">Unsung Heroes</span></p>
<p class="in-para"><span href="#/Index#Idx" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?094e388c